import { pluralRu } from '@outsource/shared/ru';
import { useState } from 'react';
import { toast } from '../../lib/toast';
import { AuthCard } from './AuthCard';
import { CodeForm } from './CodeForm';
import { useMfaVerify } from './queries';

/** Every login online after Keycloak (W20): the code from the app, or a recovery code instead. */
export function MfaVerifyScreen({ email }: { readonly email: string }) {
  const verify = useMfaVerify();
  const [isRecovery, setIsRecovery] = useState(false);

  const submit = (code: string) =>
    verify.mutate(code, {
      onSuccess: ({ recoveryCodesLeft }) => {
        if (isRecovery) toast.show(`Вход по резервному коду · осталось ${recoveryCodesLeft} ${pluralRu(recoveryCodesLeft, 'код', 'кода', 'кодов')}`);
      },
    });
  const switchMode = () => {
    verify.reset();
    setIsRecovery((value) => !value);
  };

  return (
    <AuthCard title="Подтвердите вход" email={email}>
      <p className="text-fg-2">
        {isRecovery ? 'Введите один из резервных кодов, сохранённых при подключении приложения.' : 'Откройте приложение-аутентификатор и введите 6-значный код.'}
      </p>
      <CodeForm
        key={isRecovery ? 'recovery' : 'app'}
        label={isRecovery ? 'Резервный код' : 'Код из приложения'}
        submitLabel="Войти"
        isAppCode={!isRecovery}
        isPending={verify.isPending}
        error={verify.error}
        onSubmit={submit}
      />
      <button type="button" className="self-start text-fg-2 underline underline-offset-2 hover:text-fg-1" onClick={switchMode}>
        {isRecovery ? 'Ввести код из приложения' : 'Нет доступа к телефону? Ввести резервный код'}
      </button>
    </AuthCard>
  );
}
